export const formatCountAsWord = (count: number) => {
  const words = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
  ];

  // Only use the word list if the index exists and the element is defined
  if (
    Number.isInteger(count) &&
    count >= 0 &&
    count < words.length &&
    typeof words[count] === "string"
  ) {
    return words[count];
  }

  return count.toString();
};
